;(function() {
  'use strict'

  service.$inject = ["AUTH_EVENTS", "$q", "$rootScope", "postsResource", "Message"];
  angular.module('core.services').factory('messagesService', service)

  /* @ngInject */
  function service(AUTH_EVENTS, $q, $rootScope, postsResource, Message) {
    $rootScope.$on(AUTH_EVENTS.loginSuccess, refresh)
    $rootScope.$on(Message.Events.CREATED, refresh)
    $rootScope.$on(Message.Events.UPDATED, refresh)
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, reset)

    var States = {
      IDLE: 'idle',
      LOADING: 'loading',
      READY: 'ready',
      NONE: 'none',
      ERROR: 'error',
    }

    var messages = {
      list: [],
      refresh: refresh,
      state: States.IDLE,
      error: null,
    }

    return {
      get: get,
    }

    function get() {
      messages.promise = refresh(true)
      return messages
    }

    function refresh(isGetter) {
      isGetter = isGetter === true

      return $q(function(resolve, reject) {
        if (
          isGetter &&
          (messages.state === States.READY || messages.state === States.NONE)
        ) {
          return resolve(messages.list)
        }
        messages.state = States.LOADING
        postsResource
          .get({ orderBy: 'updatedAt desc' })
          .success(function(x, resp) {
            resp = _.map(resp, function(message) {
              return new Message().fromServer(message)
            })
            angular.copy(resp, messages.list)

            // DEBUG (hack first mood)
            // messages.list[0].moodCurrent = '1';

            resolve(messages.list)
            messages.state =
              messages.list.length > 0 ? States.READY : States.NONE
          })
          .error(function(response, status) {
            messages.error = {
              response: response,
              status: status,
            }
            reject(messages.error)
            messages.state = States.ERROR
          })
      })
    }

    function reset() {
      angular.copy([], messages.list)
      messages.state = States.IDLE
    }
  }
})()
